import { IMithrilComponent } from '../../components/mithril.component';
import { addStyles } from '../../components/theme';
import { DRAGON_ID, DRAGON_TYPE, findDragonNode, handleMouseMove } from '../../dom';
import { m, type MithrilVNode } from '../../mithril';
import { TagState } from '../../page/tag.state';
import { Services } from '../../services';
import { CustomMapOverlay } from './tag.map.overlay';

export const CSS = {
	container: 'c-Map',
};

addStyles({
	[CSS.container]: {
		width: '100%',
		height: '100%',
	},
});

export class TagMap extends IMithrilComponent {
	name = 'TagMap';

	state: TagState;
	map: google.maps.Map | null = null;
	overlay: CustomMapOverlay | null = null;

	private streetModeListener: google.maps.MapsEventListener | null = null;
	private mapTypeListener: google.maps.MapsEventListener | null = null;
	private enterTime: number | null = null;
	private mapContext: string;

	constructor(state: TagState, mapContext: string) {
		super();
		this.state = state;
		this.mapContext = mapContext;
	}

	override onCreate(vnode: MithrilVNode) {
		this.map = Services.Map.attach(vnode.dom);
		this.state.map.setMap(this.map);
		this.map.setMapTypeId(Services.Map.getMapType(this.mapContext, 'roadmap'));
		this.map.set('streetViewControl', true);
		this.mapTypeListener = Services.Map.listenMapType(this.mapContext);
		this.overlay = new CustomMapOverlay(this.state.map, this.map);

		Services.Analytics.trackEvent(Services.Analytics.EventCategory.BigMap, 'map:create', 'create', 1);
		this.streetModeListener = this.map.getStreetView().addListener('visible_changed', () => this.trackStreetViewMode());
	}

	override onRemove() {
		if (this.overlay) {
			this.overlay.setMap(null);
		}
		if (this.streetModeListener) {
			this.streetModeListener.remove();
		}
		if (this.mapTypeListener) {
			this.mapTypeListener.remove();
		}
	}

	onBeforeRemove(vnode: MithrilVNode) {
		if (this.overlay) {
			this.overlay.setMap(null);
		}
		if (this.streetModeListener) {
			this.streetModeListener.remove();
		}
		if (this.mapTypeListener) {
			this.mapTypeListener.remove();
		}
	}

	get nodes(): MithrilVNode {
		if (!Services.Map.isReady) {
			return null;
		}

		return m('div', {
			className: CSS.container,
			onmousemove: handleMouseMove,
			onclick: (e) => this.handleMouseClick(e),
		});
	}

	handleMouseClick(e: MouseEvent) {
		const node = findDragonNode(e);
		if (node == null) {
			return;
		}
		if (e.preventDefault) {
			e.preventDefault();
		}
		const id = node.getAttribute(DRAGON_ID);
		const type = node.getAttribute(DRAGON_TYPE);
		this.state.map.zoomToId(type, id);
	}

	private trackStreetViewMode() {
		if (this.map == null) {
			return;
		}
		const panorama = this.map.getStreetView();
		if (panorama.getVisible()) {
			this.enterTime = Date.now();
			Services.Analytics.trackEvent(Services.Analytics.EventCategory.BigMap, 'streetview:enter');
		} else {
			Services.Analytics.trackEvent(
				Services.Analytics.EventCategory.BigMap,
				'streetview:exit',
				null,
				Date.now() - (this.enterTime ?? 0)
			);
		}
	}
}
